<template>
  <div class="coinSettings">
    <div class="coinSettings__select">
     <div data-testid="coin-series-select">
      <simple-select2
          class="seriesSelect"
          :data-source="seriesSource"
          v-model="selectedSeries"
          placeholder="Серия"
          @input="seriesInputHandler"
      ></simple-select2>

   </div>
    <div data-testid="coin-number-select">
      <scroll-select2
          v-model="selectedCoinId"
          placeholder="Номер"
          :use-search="true"
          :data-source="coinsSource"
          :busy="dataLoading"
          :has-more-data-fn="getHasMoreData"
          :next-data-fn="loadCoinsNextPage"
          :start-search-fn="startSearchCoins"
      />
    </div>
  </div>
  </div>

</template>
<script>
import {computed, onMounted, ref, watch} from "vue";
import SimpleSelect2 from "@/components/shared/SimpleSelect2.vue";
import {useCoinSeriesStore} from "@/store/coin-series";
import ScrollSelect2 from "@/components/shared/ScrollSelect2.vue";
import {useCoinsStore} from "@/store/coins";
import usePagination from "@/composables/pagination";

export default {
  name: "CoinSelect",
  components: {ScrollSelect2, SimpleSelect2},
  props: ['productId'],
  emits: ['selectCoin'],

  setup(props, { emit }) {

    const selectedSeries = ref(null)
    const selectedCoinId = ref('')

    const coinSeriesStore = useCoinSeriesStore();
    const coinsStore = useCoinsStore();
    const coinsPagination = usePagination(coinsStore, 20, false);
    const series = computed(() => {
      return coinSeriesStore.items;
    })

    const seriesSource = computed(() => {
      return series.value.map (item => ({id: item, text: item}))
    })
    const coinsSource = computed(() => {
      // console.log('page data', JSON.stringify(coinsPagination.pageData.value, null,2))
      return (coinsStore.items || []).map(item => ({id: item.id, text: item.number}))
    })
    const dataLoading = computed(() => {
      return coinsPagination.loading.value;
    })

    async function seriesInputHandler() {
      selectedCoinId.value = null
      await coinsStore.clearData();
    }

    async function loadCoinsNextPage() {
      await coinsPagination.incPage();
    }

    function getHasMoreData() {
      return coinsPagination.hasMoreData.value;
    }

    async function startSearchCoins(term, isMore) {
      console.log('coins start search ', term);
      if (!selectedSeries.value) {
         return false;
      }
      const params = {
        product_id: props.productId,
        series: selectedSeries.value,
      };
      if (term) {
        params.search_term = term.toLowerCase();
      }
     if (!isMore) {
        await coinsPagination.initLoad(params)
     } else {
       await coinsPagination.incPage();
     }
      return true;
    }

    onMounted(async () => {
      await coinSeriesStore.loadCoinSeries(props.productId);
      await coinsStore.clearData();
    })

    watch(selectedCoinId, (value) => {
      emit('selectCoin', value);
    });

    return {
      selectedSeries,
      series,
      selectedCoinId,
      seriesSource,
      coinsSource,
      getHasMoreData,
      dataLoading,
      loadCoinsNextPage,
      startSearchCoins,
      seriesInputHandler
    }
  }
}
</script>



<style scoped lang="scss">
.coinSettings {
  padding: 10px 0;

  &__select {
    display: flex;
    align-items: center;
    gap: 20px;

    @include respond-to('sm') {
      flex-direction: column;
      align-items: stretch;
    }
  }
}

.seriesSelect {
  width: 100%;
}
</style>
